export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20composition%20of%20soft%20warm%20peach%20cream%20and%20beige%20organic%20shapes%20with%20subtle%20geometric%20grid%20overlays%20suggesting%20organized%20data%20systems%2C%20gentle%20gradient%20transitions%2C%20clean%20minimalist%20aesthetic%2C%20serene%20airy%20atmosphere%2C%20soft%20diffused%20lighting%2C%20contemporary%20European%20design%20sensibility%2C%20no%20text%20no%20people%2C%20elegant%20data%20visualization%20abstract%20art%2C%20harmonious%20balanced%20composition%20with%20delicate%20layered%20transparency%20and%20flowing%20curves&width=1600&height=900&seq=hero-bg-v2-2026-x1&orientation=landscape"
          alt="ItaobuySpreadsheet smart product comparison platform"
          title="ItaobuySpreadsheet - Smart Product Comparison & Shopping Data Platform"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            <span className="text-xs md:text-sm text-background-50 font-medium">
              Trusted Product Intelligence System
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-background-50 leading-tight mb-4 font-heading">
            ItaobuySpreadsheet
            <span className="block text-2xl md:text-3xl lg:text-4xl font-semibold mt-2 text-background-50/90">
              The Smart Product Comparison Spreadsheet for Smarter Shopping
            </span>
          </h1>

          <p className="text-sm md:text-base text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            Discover curated product data, price comparisons, and trusted supplier insights using the most advanced itaobuy spreadsheet system designed for smarter global shopping decisions in 2026.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-all whitespace-nowrap"
            >
              <i className="ri-rocket-line mr-2"></i>
              Itaobuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-background-50 text-foreground-950 rounded-md hover:bg-background-100 transition-all whitespace-nowrap"
            >
              <i className="ri-shopping-cart-line mr-2"></i>
              Buy It Now
            </a>
            <a
              href="#categories"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-medium text-background-50 border border-background-50/40 rounded-md hover:bg-background-50/10 transition-all whitespace-nowrap"
            >
              Explore Categories
              <i className="ri-arrow-down-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-8 rounded-full border-2 border-background-50/40 flex items-start justify-center p-1">
          <div className="w-1 h-2 rounded-full bg-background-50/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}